import * as React from 'react';
import { RankItem } from '@/fetch.ts';
import starback from '@images/kingno1.png';
import starbackn from '@images/kingnon.png';
import Men from '@images/man.png';
import Default from '@images/default.png';
interface Props extends RankItem {
  current: number,
}
const KingItem: React.FC<Props> = props => {
  return (
    <li className='star' style={{backgroundImage: `url('${props.iRank === 1 ? starback : starbackn}')`}}>
      <div className='rank'>
        <div style={{'WebkitTextFillColor': `${props.iRank !== 1 ? 'rgb(102, 222, 255)' : 'rgb(247, 194, 68)'}`}}>{props.iRank}</div>
      </div>
      {
        // props.current !== 2 ?
        true ?
        <div className='avatar' onClick={() => (window.open('https://m.huya.com/' + props.tJump.iRoomId, '_blank'))}>
          <img
            src={props.sPortraitUrl}
            title={props.sNickName}
            onError={(event: any): void => {
              event.target.onerror = null;
              event.target.src = Men;
            }}
          />
        </div>
        :
        <div className='avatar-small'>
          <img
            src={props.sLogoUrl}
            title={props.sNickName}
            onError={(event: any): void => {
              event.target.onerror = null;
              event.target.src = Default;
            }}
            onClick={() => (window.open('https://m.huya.com/' + props.tJump.iRoomId, '_blank'))}
          />
        </div>
      }
      <div className='introduce'>
        <div className='name'>
          <h4 onClick={() => (window.open('https://m.huya.com/' + props.tJump.iRoomId, '_blank'))}>{props.sNickName}</h4>
        </div>
        <p className='text'>{props.sDesc}</p>
      </div>
      <div className='score'>
        <h4>{props.lScore}</h4>
        <p>星光</p>
      </div>
    </li>
  )
}

export default KingItem;